import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <img {...{
      "src": "./../images/turbonomic/00_turbo.png",
      "alt": "turbo"
    }}></img>
    <p>{`In this chapter you will learn how to install a Turbonomic Instance and how to configure some basic functionality.`}</p>
    <InlineNotification kind="warning" mdxType="InlineNotification"> 
      <p><strong parentName="p">{`Turbonomic License Key `}</strong></p>
      <p>{`If you are not following this as part of an IBM training course, you will have to provide your own Turbonomic License key.`}</p>
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      